<template>
  <div>
    <!--    <h6 class="card-title mb-4 font-size-10">Add a New Bank</h6>-->

    <form @submit.prevent="createBank">
      <div class="row">
        <div class="col-sm-6">
          <div>
            <BaseInput
              :inputType="'text'"
              v-model="createBankFormBody.bankName"
              placeholder="Bank Name"
              :hasPreIcon="false"
              :label="'Bank Name'"
              :class="{
                error: $v.createBankFormBody.bankName.$error
              }"
              @blur="$v.createBankFormBody.bankName.$touch()"
            >
            </BaseInput>

            <template v-if="$v.createBankFormBody.bankName.$error">
              <p
                v-if="!$v.createBankFormBody.bankName.required"
                class="form-error-message"
              >
                Bank Name is required
              </p>
            </template>
          </div>

          <div>
            <BaseInput
              :inputType="'text'"
              v-model="createBankFormBody.bankNIBSSCode"
              placeholder="NIBSS Code"
              :hasPreIcon="false"
              :label="'NIBSS Code'"
              :class="{
                error: $v.createBankFormBody.bankNIBSSCode.$error
              }"
              @blur="$v.createBankFormBody.bankNIBSSCode.$touch()"
            >
            </BaseInput>

            <template v-if="$v.createBankFormBody.bankNIBSSCode.$error">
              <p
                v-if="!$v.createBankFormBody.bankNIBSSCode.required"
                class="form-error-message"
              >
                NIBSS Code is required
              </p>
            </template>
          </div>

          <div>
            <BaseInput
              :inputType="'text'"
              v-model="createBankFormBody.bankAddress"
              placeholder="Address"
              :hasPreIcon="false"
              :label="'Address'"
              :class="{
                error: $v.createBankFormBody.bankAddress.$error
              }"
              @blur="$v.createBankFormBody.bankAddress.$touch()"
            >
            </BaseInput>

            <template v-if="$v.createBankFormBody.bankAddress.$error">
              <p
                v-if="!$v.createBankFormBody.bankAddress.required"
                class="form-error-message"
              >
                Address is required
              </p>
            </template>
          </div>
        </div>

        <div class="col-sm-6">
          <div>
            <BaseInput
              :inputType="'text'"
              v-model="createBankFormBody.bankCity"
              placeholder="City"
              :hasPreIcon="false"
              :label="'City'"
              :class="{
                error: $v.createBankFormBody.bankCity.$error
              }"
              @blur="$v.createBankFormBody.bankCity.$touch()"
            >
            </BaseInput>

            <template v-if="$v.createBankFormBody.bankCity.$error">
              <p
                v-if="!$v.createBankFormBody.bankCity.required"
                class="form-error-message"
              >
                City is required
              </p>
            </template>
          </div>

          <div>
            <BaseInput
              :inputType="'text'"
              v-model="createBankFormBody.bankState"
              placeholder="State"
              :hasPreIcon="false"
              :label="'State'"
              :class="{
                error: $v.createBankFormBody.bankState.$error
              }"
              @blur="$v.createBankFormBody.bankState.$touch()"
            >
            </BaseInput>

            <template v-if="$v.createBankFormBody.bankState.$error">
              <p
                v-if="!$v.createBankFormBody.bankState.required"
                class="form-error-message"
              >
                State is required
              </p>
            </template>
          </div>

          <div>
            <BaseInput
              :inputType="'text'"
              v-model="createBankFormBody.bankCountry"
              placeholder="Country"
              :hasPreIcon="false"
              :label="'Country'"
              :class="{
                error: $v.createBankFormBody.bankCountry.$error
              }"
              @blur="$v.createBankFormBody.bankCountry.$touch()"
            >
            </BaseInput>

            <template v-if="$v.createBankFormBody.bankCountry.$error">
              <p
                v-if="!$v.createBankFormBody.bankCountry.required"
                class="form-error-message"
              >
                Country is required
              </p>
            </template>
          </div>
        </div>
      </div>

      <p class="text-right">
        <span v-if="bank.moduleLoading" class="formLoaderHold">
          <BaseComponentLoader />
        </span>
        <span v-else>
          <button type="submit" class="btn btn-primary mr-1">
            Create Bank
          </button>
        </span>
      </p>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  name: "CreateBank",
  data() {
    return {
      createBankFormBody: this.createFreshCreateBankFormBodyObject(),

      options: [
        "Alaska",
        "Hawaii",
        "California",
        "Nevada",
        "Oregon",
        "Washington",
        "Arizona",
        "Colorado",
        "Idaho",
        "Montana",
        "Nebraska",
        "New Mexico",
        "North Dakota",
        "Utah",
        "Wyoming",
        "Alabama",
        "Arkansas",
        "Illinois",
        "Iowa"
      ]
    };
  },
  computed: {
    ...mapState(["bank"])
  },
  validations: {
    createBankFormBody: {
      bankName: { required },
      bankNIBSSCode: { required },
      bankAddress: { required },
      bankCity: { required },
      bankState: { required },
      bankCountry: { required }
    }
  },
  methods: {
    createBank() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store
          .dispatch("bank/createBank", this.createBankFormBody, { root: true })
          .then(() => {
            this.createBankFormBody = {
              source: "web"
            };
            this.$v.$reset();
          })
          .catch(() => {});
      }
    },
    createFreshCreateBankFormBodyObject() {
      return {
        source: "web"
      };
    }
  }
};
</script>

<style scoped>
.font-size-10 {
  font-size: 10px;
}
</style>
